<template>
  <highcharts :options="options" ref="chart"></highcharts>
</template>

<script>
import { mapState } from "vuex";
import { history_trend_options } from "@/options/chart";
import { waterValueV } from "@/options/common";
// import { debounce } from "lodash";
import debounce from "lodash/debounce";
import { isCheckNumber } from "@/utils/utils";
export default {
  data() {
    return {
      chart: null,
      options: history_trend_options
    };
  },
  props: [
    "timeType",
    "sensortype",
    "dateRange",
    "isShowTree",
    "chartMin",
    "chartMax",
    "waterNorm"
  ],
  computed: {
    ...mapState([
      "checkedHistoryStationIds",
      "checkedGfStationIds",
      "historyData",
      "gfSnData",
      "siderCollapsed"
    ])
  },
  watch: {
    async checkedHistoryStationIds() {
      this.chart = this.$refs.chart?.chart;
      this.chart?.showLoading();
      await this.$store.dispatch("getHistoryData", {
        timeType: this.timeType,
        dateRange: this.dateRange
      });
      this.drawPlot();
    },
    async checkedGfStationIds() {
      this.chart = this.$refs.chart?.chart;
      this.chart?.showLoading();
      await this.$store.dispatch("getGfSnData", {
        timeType: this.timeType,
        dateRange: this.dateRange
      });
      this.drawPlot();
    },
    async dateRange() {
      this.chart = this.$refs.chart.chart;
      this.chart.showLoading();
      await this.$store.dispatch("getGfSnData", {
        timeType: this.timeType,
        dateRange: this.dateRange
      });
      await this.$store.dispatch("getHistoryData", {
        timeType: this.timeType,
        dateRange: this.dateRange
      });
      this.drawPlot();
    },
    async timeType() {
      this.chart = this.$refs.chart?.chart;
      this.chart?.showLoading();
      await this.$store.dispatch("getGfSnData", {
        timeType: this.timeType,
        dateRange: this.dateRange
      });
      await this.$store.dispatch("getHistoryData", {
        timeType: this.timeType,
        dateRange: this.dateRange
      });
      this.drawPlot();
    },
    sensortype() {
      this.chart = this.$refs.chart?.chart;
      this.chart?.showLoading();
      this.drawPlot();
    },
    waterNorm() {
      this.chart = this.$refs.chart?.chart;
      this.chart?.showLoading();
      this.drawPlot();
    },
    isShowTree() {
      this.$nextTick(() => {
        this.chart = this.$refs.chart?.chart;
        this.chart?.reflow();
      });
    },
    siderCollapsed() {
      setTimeout(() => {
        // 手动触发resize事件
        const resizeEvent = new Event("resize");
        window.dispatchEvent(resizeEvent);
        this.chart = this.$refs.chart?.chart;
        this.chart?.reflow();
      }, 100);
    },
    chartMin(v) {
      this.chart = this.$refs.chart?.chart;
      if (this.chart) {
        this.chart.update({
          yAxis: {
            min: isCheckNumber(v) ? v : null
          }
        });
      }
    },
    chartMax(v) {
      this.chart = this.$refs.chart?.chart;
      if (this.chart) {
        this.chart.update({
          yAxis: {
            max: isCheckNumber(v) ? v : null
          }
        });
      }
    }
  },
  mounted() {
    this.chart = this.$refs.chart?.chart;
    this.chart?.showLoading();
    this.drawPlot();
  },
  methods: {
    drawPlot: debounce(function() {
      console.time("drawPlot");
      this.$emit("resetMinMax");
      let yAxisMax = Number.NEGATIVE_INFINITY;
      let yAxisMin = Number.POSITIVE_INFINITY;
      this.options.series = [];
      this.options.annotations = [];
      this.options.yAxis.plotLines = [];
      this.options.yAxis.min = null;
      this.options.yAxis.max = null;

      if (
        this.checkedHistoryStationIds.length > 0 ||
        this.checkedGfStationIds.length > 0
      ) {
        const valueVInfo = waterValueV.find(x => x.value == this.sensortype);

        let sensorTypeInfo = G_SENSOR_DATA_TYPE_INFO.find(
          a => a.value === this.sensortype
        );
        this.options.title.text = sensorTypeInfo.label + "历史数据曲线";
        this.options.yAxis.title.text =
          sensorTypeInfo.label + "(" + sensorTypeInfo.unit + ")";
        let timeList = [];
        for (let item of this.historyData) {
          const sColumns = item.columns;
          const sSeriesId = this.sensortype + ":" + item.id;
          const sIndex = sColumns.indexOf(this.sensortype);
          if (valueVInfo) {
            let tempArr = this.$_.map(item.datas, x => x[sIndex]);
            let tempMax = this.$_.max(tempArr);
            let tempMin = this.$_.min(tempArr);
            yAxisMax = tempMax > yAxisMax ? tempMax : yAxisMax;
            yAxisMin = tempMin < yAxisMin ? tempMin : yAxisMin;
          }
          let series = {
            id: sSeriesId,
            name: item.station[0].name + ":" + sensorTypeInfo.label,
            data: this.$_.map(item.datas, x => [x[0], x[sIndex]]),
            data_type: this.sensortype,
            time_type: this.timeType,
            marker: { radius: 0, symbol: "square", enabled: true },
            animation: false
          };
          this.options.series.push(series);
          timeList.push(this.$_.map(item.datas, x => x[0]));
        }
        for (let item of this.gfSnData) {
          const gColumns = item.columns;
          const gSeriesId = this.sensortype + ":" + item.id;
          const gIndex = gColumns.indexOf(
            this.sensortype == "temperature"
              ? "water_temperature"
              : this.sensortype
          );
          if (valueVInfo) {
            let tempArr = this.$_.map(item.datas, x => x[gIndex]);
            let tempMax = this.$_.max(tempArr);
            let tempMin = this.$_.min(tempArr);
            yAxisMax = tempMax > yAxisMax ? tempMax : yAxisMax;
            yAxisMin = tempMin < yAxisMin ? tempMin : yAxisMin;
          }
          let series = {
            id: gSeriesId,
            name: item.station[0].Name + ":" + sensorTypeInfo.label,
            data: this.$_.map(item.datas, x => [x[0], x[gIndex]]),
            dashStyle: "ShortDash",
            data_type: this.sensortype,
            time_type: this.timeType,
            marker: { radius: 0, symbol: "square", enabled: true },
            animation: false
          };
          this.options.series.push(series);
          timeList.push(this.$_.map(item.datas, x => x[0]));
        }

        if (valueVInfo) {
          timeList = this.$_.orderBy(this.$_.uniq(timeList.flat()));
          if (valueVInfo.value !== "ph") {
            if (this.waterNorm.length > 0) {
              this.waterNorm.forEach(w => {
                const wSeriesId = this.sensortype + `:${w}类水质标准`;
                let series = {
                  id: wSeriesId,
                  name: `${w}类水质标准`,
                  data: timeList.map(x => [x, valueVInfo["value_" + w]]),
                  dashStyle: "dash",
                  clip: false, // 解决峰值线溢出不展示问题
                  lineWidth: 3,
                  color: "red",
                  zIndex: 2,
                  marker: { radius: 0, enabled: true },
                  animation: false,
                  data_type: this.sensortype,
                  time_type: this.timeType,
                  is_water_V: true // 是否V类水质标准
                };
                this.options.series.push(series);
                this.options.annotations.push({
                  id: wSeriesId,
                  labels: [
                    {
                      point: {
                        x: timeList[timeList.length - 1],
                        y: valueVInfo["value_" + w],
                        xAxis: 0,
                        yAxis: 0
                      },
                      text: sensorTypeInfo.label + `${w}类水质标准`,
                      shape: "rect",
                      padding: 0,
                      y: 0,
                      x: 50
                    }
                  ],
                  labelOptions: {
                    backgroundColor: "#fff",
                    borderWidth: 0,
                    borderColor: "#fff",
                    style: {
                      fontSize: "18px"
                    }
                  },
                  draggable: "xy",
                  zIndex: 1
                });
              });
            }
          } else {
            let plotLines = [];
            valueVInfo.value_V.forEach(v => {
              const vSeriesId = this.sensortype + `:${v}类PH值`;
              plotLines.push({
                id: vSeriesId,
                width: 3,
                value: v,
                dashStyle: "dash",
                color: "red",
                zIndex: 2,
                label: {
                  text: sensorTypeInfo.label + " " + v,
                  align: "right",
                  x: -60,
                  y: -10,
                  style: {
                    fontSize: "18px"
                  }
                }
              });
              this.options.yAxis.plotLines = plotLines;
            });
          }

          if (valueVInfo.value == "dissolved_oxygen") {
            this.options.yAxis.min =
              yAxisMin < valueVInfo.value_V ? yAxisMin : valueVInfo.value_V;
          } else if (valueVInfo.value == "ph") {
            this.options.yAxis.min =
              yAxisMin < valueVInfo.value_V[0]
                ? yAxisMin
                : valueVInfo.value_V[0];
            this.options.yAxis.max =
              yAxisMax > valueVInfo.value_V[1]
                ? yAxisMax
                : valueVInfo.value_V[1];
          } else {
            this.options.yAxis.max =
              yAxisMax > valueVInfo.value_V
                ? yAxisMax
                : valueVInfo.value_V + 0.1;
          }
        }
      }
      this.chart?.hideLoading();
      console.timeEnd("drawPlot");
    }, 240)
  }
};
</script>

<style scoped>
.chart {
  height: 100%;
  width: 100%;
}
</style>
